module.exports = __webpack_public_path__ + "static/media/Facebook_Guide_Chin_iOS.edaa7da2.pdf";